import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import Header from "../../components/layout/header/header";
import { MdEdit, MdSave, MdDelete, MdAddCircle, MdFilterList } from "react-icons/md";
import LeftNav from "../../components/layout/leftNav/leftNav";
import loading from "../../assets/images/common/loading.gif";
import DataTable from "react-data-table-component";
import { Tooltip } from '@mui/material';
import { fetchDataRead } from "../../Utility";

function AddNewSections() {
  const navigate = useNavigate();
  const userData = sessionStorage.getItem('user');
  const [sections, setSections] = useState([])
  const userObj = userData ? JSON.parse(userData) : {};
  const [editId, setEditId] = useState(null);
  const [classes, setClasses] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [academic, setacademic] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [Teachers, setTeachers] = useState(null);
  const [NonTeachers, setNonTeachers] = useState(null);
  const [school, setSchool] = useState(null);
  const [filteredClasses, setFilteredClasses] = useState([]);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const routeLocation = useLocation();

  const [filter, setFilter] = useState({
    section_name: "",
    class_id: 0,
    room_number: "",
    academic_year_id: 0,
    action: "FILTER"
  });
  const [form, setForm] = useState({
    section_id: "",
    section_name: "",
    class_id: "",
    room_number: "",
    school_id: "",
    school_name: "",
    academic_year_id: null,
    academic_year_name: "",
    cooridinator_id: "",
    is_active: "A"
  })

  useEffect(() => {
    const sectionData = routeLocation.state?.sectionData;

    if (sectionData && sectionData.section_id) {
      setForm({
        section_id: sectionData.section_id,
        section_name: sectionData.section_name || "",
        class_id: sectionData.class_id || "",
        room_number: sectionData.room_number || "",
        class_teacher_id: sectionData.class_teacher_id || "",
        academic_coordinator_id: sectionData.academic_coordinator_id || "",
        school_id: sectionData.school_id || "",
        school_name: sectionData.school_name || "",
        academic_year_id: sectionData.academic_year_id || "",
        academic_year_name: sectionData.academic_year_name || "",
        is_active: sectionData.is_active || "A"
      });
      setEditId(sectionData.section_id);
    } else {
      setForm({
        section_id: "",
        section_name: "",
        class_id: "",
        room_number: "",
        school_id: "",
        school_name: "",
        academic_year_id: "",
        academic_year_name: "",
        class_teacher_id: "",
        academic_coordinator_id: "",
        is_active: "A"
      });
      setEditId(null);
    }

    // Remove state from URL to prevent it from persisting
    window.history.replaceState({}, document.title);
  }, [routeLocation.state?.sectionData?.section_id]);



  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [id]: value,
    }));

  };
  useEffect(() => {

    setIsLoading(true);
    // fetchSections().finally(() => setIsLoading(false));
  }, []);
  const fetchSections = async (academicYearId) => {
    try {
      const response = await axios.post(baseUrl + "/Sections/", {
        action: "FILTER", school_id: userObj.school_id,
        academic_year_id: academicYearId || form.academic_year_id || userObj.academic_year_id
      });
      setSections(response.data);
      setFilteredClasses(response.data);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };


  useEffect(() => {
    fetchClasses();
    fetchAcademicYear();
    // fetchschool();
    fetchNonTeachers();
    fetchTeachers();

  }, []);

  const fetchClasses = async () => {
    try {
      const response = await axios.post(baseUrl + "/classes/", {
        action: "READ",
        school_id: userObj.school_id
      });
      setClasses(response.data);

    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };
  const handleEditClick = (section_id) => {
    const sectionToEdit = sections.find(sec => sec.section_id === section_id);
    if (sectionToEdit) {
      setForm({
        section_id: sectionToEdit.section_id,
        section_name: sectionToEdit.section_name || "",
        class_id: sectionToEdit.class_id || 0,
        room_number: sectionToEdit.room_number || "",
        class_teacher_id: sectionToEdit.class_teacher_id || 0,
        academic_coordinator_id: sectionToEdit.academic_coordinator_id || 0,
        school_id: sectionToEdit.school_id || "",
        school_name: sectionToEdit.school_name || "",
        academic_year_id: sectionToEdit.academic_year_id || 0,
        academic_year_name: sectionToEdit.academic_year_name || "",
        is_active: sectionToEdit.is_active || "A"
      });
      setEditId(sectionToEdit.section_id);
    } else {
      toast.error("Selected section not found or already inactive.");
    }
  };


  const handleDeleteClick = async (section_id) => {
    const confirmDelete = window.confirm('Are you sure you want change the status?');
    if (!confirmDelete) {
      return;
    }
    const requestBody = {
      section_id: section_id,
      action: "DELETE"
    };
    try {
      const response = await axios.post(baseUrl + "/Sections/", requestBody, {
        headers: {
          'Content-Type': 'application/json'
        },
      });
      if (response.status < 200 || response.status >= 300) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      toast.success("Record Set to InActive");
      fetchSections();
    } catch (error) {
      console.error('Error:', error);
    }
  };
  useEffect(() => {

    setIsLoading(true);
    fetchSections().finally(() => setIsLoading(false));
  }, []);
  const fetchTeachers = async () => {
    try {
      const response = await axios.post(baseUrl + "/employees/", {
        action: "READ",
        school_id: userObj.school_id
      });
      setTeachers(response.data);

    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };
  const fetchNonTeachers = async () => {
    try {
      const response = await axios.post(baseUrl + "/employees/", {
        action: "READ",
        school_id: userObj.school_id
      });
      setNonTeachers(response.data);

    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };
  const readOnlyRoles = ["Class Teacher", "Teacher"];
  const canSubmit = !readOnlyRoles.includes(userObj.role_name?.trim());


  const fetchAcademicYear = async () => {
    try {
      const response = await axios.post(baseUrl + "/AcademicYear/", {
        action: "DROPDOWNREAD",
        school_id: userObj.school_id,
      });

      const years = response.data || [];

      setacademic(years);

    } catch (error) {
      console.error("Error fetching academic years:", error);
    }
  };

  const fetchschool = async () => {
    try {
      const response = await axios.post(baseUrl + "/schoolmaster/", {
        action: "READ",
      });
      setSchool(response.data);

    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const handleAcademicYearChange = (e) => {
    const selectedYearId = parseInt(e.target.value) || "";
    const selectedYear = (academic || []).find(year => year.academic_year_id === selectedYearId);
    setForm((prevForm) => ({
      ...prevForm,
      academic_year_id: selectedYearId,
      academic_year_name: selectedYear ? selectedYear.academic_year_name : ""
    }));
    fetchSections(selectedYearId);
  };



  const handleSubmit = async (e) => {
    e.preventDefault();



    const formData = {
      section_name: form.section_name,
      room_number: form.room_number,
      class_id: form.class_id || 0,
      class_teacher_id: form.class_teacher_id || 0,
      academic_coordinator_id: form.academic_coordinator_id || 0,
      is_active: form.is_active || "A",
      school_id: userObj.school_id,
      academic_year_id: form.academic_year_id || 0,
      action: editId !== null ? 'UPDATE' : 'CREATE'
    };
    if (editId !== null) {
      formData.section_id = editId;
    }
    try {
      console.log(formData)
      const response = await axios.post(baseUrl + "/Sections/", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("API Response", response.data);
      if (editId !== null) {
        toast.success("Record Updated Successfully", { position: "top-right" });
        setEditId(null);
        setForm({
          section_id: "",
          section_name: "",
          class_id: "",
          class_teacher_id: "",
          academic_coordinator_id: "",
          room_number: "",
          school_id: "",
          school_name: "",
          academic_year_id: "",
          is_active: "A"
        });
        fetchSections();
      } else {
        toast.success("Record Added Successfully", { position: "top-right" });
        setForm({
          section_id: "",
          section_name: "",
          class_id: "",
          class_teacher_id: "",
          academic_coordinator_id: "",
          room_number: "",
          school_id: "",
          school_name: "",
          academic_year_id: "",
          is_active: "A"
        });
        await fetchSections();
      }

    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;

        if (status === 400 && data.error === "Record already exists.") {

          toast.error("Record already exists.", { position: "top-right" });

        }
        else if (status === 402) {
          toast.error("Class Teacher Is Already Assigned To This Class And Section", { position: "top-right" });
        }
        else if (status === 401) {
          toast.error("Room Number is already Assigned")
        }
        else if (status === 500) {
          toast.error("Error submitting data: " + (data.error || error.message), { position: "top-right" });
        } else {
          toast.error("Unexpected error occurred", { position: "top-right" });
        }
      } else {
        console.error("There was an error submitting:", error);
        toast.error("Error submitting data: " + error.message, { position: "top-right" });
      }
    }
  };

  const handleFilterSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      section_name: filter.section_name || "",
      class_id: filter.class_id || 0,
      room_number: filter.room_number || "",
      academic_year_id: userObj.academic_year_id || 0,
      school_id: userObj.school_id,
      action: "FILTER"
    };
    try {
      const response = await axios.post(baseUrl + "/Sections/", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const filterdata = response.data || [];
      if (filterdata.length === 0) {
        setSections([]);

      }
      else {
        setSections(filterdata);
      }
      // setShowFilterModal(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setSections([]);

      } else {
        toast.error("Failed to fetch filtered data");
      }
    }
  };

  const columns = [
    {
      name: "Class Name",
      selector: (row) => row.class_name,
      sortable: true,
      cell: (row) => (
        <Tooltip title={row.class_name}>
          <span>{row.class_name}</span>
        </Tooltip>
      ),
    },
  ];

  const searchableColumns = [
    (row) => row.academic_year_name,
    (row) => row.class_name,
    (row) => row.section_name,
    (row) => row.room_number,
    (row) => row.is_active,
  ];
  const filteredRecords = (sections || []).filter((section) =>
    searchableColumns.some((selector) => {
      const value = selector(section);
      return String(value || "")
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
    })
  );
  const handleSearchChange = (event) => {

    fetchSections();
    setSearchQuery(event.target.value);
  };
  const groupByClass = (sectionsList) => {
    const grouped = {};

    (sectionsList || []).forEach((item) => {
      const key = item.class_id;
      if (!grouped[key]) {
        grouped[key] = {
          class_id: item.class_id,
          class_name: item.class_name,
          sections: []
        };
      }
      grouped[key].sections.push(item);
    });

    return Object.values(grouped);
  };

  const groupedRecords = groupByClass(filteredRecords);
  const ExpandedComponent = ({ data }) => (
    <div
      className="expandedTableWrapper"
      style={{
        marginLeft: "100px", border: "1px solid rgb(204, 204, 204)", borderRadius: "8px", padding: "12px",
        background: "linear-gradient(135deg, rgb(249, 249, 249) 0%, rgb(230, 230, 230) 100%)", boxShadow: "rgba(0, 0, 0, 0.1) 2px 4px 10px"
      }}>

      <table className="customExpandedTable">
        <thead style={{ backgroundColor: "#dee2e6" }}>
          <tr className="border-blue">
            <th>Section</th>
            <th>Teacher</th>
            <th>Coordinator</th>
            <th>Status</th>
            {canSubmit && <th>Actions</th>}   {/* 👈 Only show header if canSubmit */}
          </tr>
        </thead>
        <tbody>
          {data.sections.map((sec, idx) => (
            <tr key={idx}>
              <td>{sec.section_name}</td>
              <td>{sec.class_teacher_name}</td>
              <td>{sec.academic_coordinator_name}</td>
              <td>{sec.is_active}</td>

              {canSubmit && (   // 👈 Only render Actions column if canSubmit
                <td>
                  <div className="d-flex gap-2">
                    <Tooltip title="Edit" arrow>
                      <span
                        className="commonActionIcons"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleEditClick(sec.section_id)}
                      >
                        <MdEdit />
                      </span>
                    </Tooltip>
                    <Tooltip title="Delete" arrow>
                      <span
                        className="commonActionIcons"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDeleteClick(sec.section_id)}
                      >
                        <MdDelete />
                      </span>
                    </Tooltip>
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );

  return (
    <>
      <ToastContainer />
      <div>
        <Container fluid>
          <Card>
            <Card.Body style={{ padding: "2px" }}>
              <form onSubmit={handleSubmit}>
                {/* <Row>
                <Col xs={12}>
                  <h6 className="commonSectionTitle">Academic Section Details</h6>
                </Col>
              </Row> */}


                <Row className="g-3 align-items-end">
                  {/* <Col md={2}>
                    <Form.Group className="commonInput">
                      <Form.Label>Academic Year</Form.Label>
                      <Form.Control
                        type="text"
                        readOnly
                        value={userObj.academic_year_name}
                        plaintext
                        className="form-control-plaintext"
                      />
                    </Form.Group>
                  </Col> */}

                  <Col md={2} className="m-0">
                    <div className="commonInput">
                      <Form.Group>
                        <Form.Label>Academic Year<span className="requiredStar">*</span></Form.Label>
                        <Form.Control
                          as="select"
                          id="academic_year_id"
                          value={form.academic_year_id}
                          onChange={handleAcademicYearChange}
                        >
                          <option value=""> Select Academic Year</option>
                          {(academic || []).map((year) => (
                            <option key={year.academic_year_id} value={year.academic_year_id}>
                              {year.academic_year_name}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={2} className="m-0">
                    <Form.Group className="commonInput ">
                      <Form.Label>
                        Class <span className="requiredStar">*</span>
                      </Form.Label>
                      <select
                        required
                        className="form-select"
                        id="class_id"
                        value={form.class_id}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled hidden>Select Class</option>
                        {(classes || [])
                          .filter((cls) => cls.is_active === "Active")
                          .map((classe) => (
                            <option key={classe.class_id} value={classe.class_id}>
                              {classe.class_name}
                            </option>
                          ))}
                      </select>
                    </Form.Group>
                  </Col>

                  <Col md={2} className="m-0">
                    <Form.Group className="commonInput">
                      <Form.Label>
                        Section <span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        id="section_name"
                        value={form.section_name}
                        maxLength={30}
                        placeholder="Enter Section"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (
                            /^[a-zA-Z0-9 +]*$/.test(value) &&
                            (value.match(/\+/g)?.length || 0) <= 1 &&
                            (value.match(/ /g)?.length || 0) <= 1
                          ) {
                            handleInputChange(e);
                          }
                        }}
                      />
                    </Form.Group>
                  </Col>

                  {/* <Col md={2}>
                    <Form.Group className="commonInput">
                      <Form.Label>
                        Room Number <span className="requiredStar">*</span>
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        id="room_number"
                        placeholder="Enter Room Number"
                        maxLength={30}
                        value={form.room_number}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z0-9]*-?[a-zA-Z0-9]*$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                      />
                    </Form.Group>
                  </Col> */}
                  <Col md={2} className="m-0">
                    <Form.Group className="commonInput">
                      <Form.Label>
                        Teacher <span className="requiredStar">*</span>
                      </Form.Label>
                      <select
                        required
                        className="form-select"
                        id="class_teacher_id"
                        value={form.class_teacher_id}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled hidden>Select Teacher</option>
                        {(Teachers || [])
                          // .filter((cls) => cls.is_active === "Active")
                          .map((t) => (
                            <option key={t.emp_id} value={t.emp_id}>
                              {t.emp_name}
                            </option>
                          ))}
                      </select>


                    </Form.Group>
                  </Col>
                  <Col md={2} className="m-0">
                    <Form.Group className="commonInput">
                      <Form.Label>
                        Co-ordinator <span className="requiredStar">*</span>
                      </Form.Label>
                      <select
                        required
                        className="form-select"
                        id="academic_coordinator_id"
                        value={form.academic_coordinator_id}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled hidden>Select Co-ordinator</option>
                        {(NonTeachers || [])
                          // .filter((cls) => cls.is_active === "Active")
                          .map((t) => (
                            <option key={t.emp_id} value={t.emp_id}>
                              {t.emp_name}
                            </option>
                          ))}
                      </select>


                    </Form.Group>
                  </Col>


                  {/* Buttons */}

                </Row>
                <div className="d-flex justify-content-between mt-1">
                  <Button
                    type="button"
                    variant="primary"
                    className="btn-info clearBtn"
                    onClick={() => {
                      setForm({
                        section_name: "",
                        class_id: "",
                        is_active: "",
                        class_teacher_id: "",
                        academic_coordinator_id: "",
                        createdby: "",
                        lastmodifiedby: "",


                      });
                      setEditId(null);
                    }}
                  >
                    Reset
                  </Button>


                  <div>
                    {canSubmit && (
                      <>
                        <Button
                          type="button"
                          variant="danger"
                          className="btn-danger secondaryBtn me-2"
                          onClick={() => window.location.reload()}
                        >
                          Cancel
                        </Button>

                        <Button
                          type="submit"
                          variant="success"
                          className="btn-success primaryBtn"
                        >
                          <MdSave style={{ marginRight: "5px" }} />
                          {editId !== null ? "Update" : "Save"}
                        </Button>
                      </>
                    )}


                  </div>
                </div>

              </form>
            </Card.Body>
          </Card>
        </Container>
      </div>

      <div className="commonDataTableHead">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            {/* <h6 className="commonTableTitle">Academic Sections</h6> */}
          </div>
          <div>
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              maxLength={30}
              className="searchInput mt-1"
              onChange={handleSearchChange}
            />
          </div>

        </div>
      </div>
      <div className="commonTable height100 mt-0" style={{ overflowY: "auto" }}>

        <div className="tableBody" style={{ maxHeight: "calc(100vh - 250px)", overflowY: "auto" }}>

          {isLoading ? (

            <div className="loadingContainer">

              <img src={loading} alt="Loading..." className="loadingGif" />

            </div>

          ) : (

            <DataTable

              className="custom-table"

              columns={columns}

              data={

                Array.isArray(groupedRecords) && groupedRecords.length > 0

                  ? groupedRecords

                  : [

                    {

                      section_id: "No records found",

                      section_name: "No records found",

                    },

                  ]

              }

              pagination={Array.isArray(groupedRecords) && groupedRecords.length > 0}

              highlightOnHover

              responsive

              fixedHeader

              fixedHeaderScrollHeight="calc(100vh - 400px)"

              expandableRows

              expandableRowsComponent={(props) => <ExpandedComponent {...props} />}

              conditionalRowStyles={[

                {

                  when: (row) => row.section_id === "No records found",

                  style: {

                    textAlign: "center",

                    fontSize: "16px",

                    backgroundColor: "#f9f9f9",

                  },

                },

              ]}

            />

          )}

        </div>

      </div>

    </>
  );

}
export default AddNewSections
